import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { Icon, Typography } from '@packages/ui/shared';

const useStyles = createUseStyles({
    helpPill: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        cursor: 'pointer',
        userSelect: 'none',
        padding: '4px 12px',
        borderRadius: 16,
        backgroundColor: '#EBF3FF',
        border: '1px solid #C9DFF7',
        transition: 'background-color 0.15s ease',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        '&:hover': {
            backgroundColor: '#DCEBFC',
        },
    },
});

// Collapsed entry point for the pop-up guidance — a small pill that reopens the banner.
export const PopupGuidanceHelpPill: FC<{ onPress: () => void }> = ({ onPress }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    return (
        <div
            className={classes.helpPill}
            onClick={onPress}
            role="button"
            aria-label={t('stisPublications:popupGuidance.helpLink', 'Pop-up settings help')}
        >
            <Icon name="info-solid" color="blueOne" size={16} />
            <Typography numberOfLines={1} style={{ fontSize: 13, fontWeight: '600', color: '#007BFF' }}>
                {t('stisPublications:popupGuidance.helpLink', 'Pop-up settings help')}
            </Typography>
        </div>
    );
};
